import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPatreon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconPatreon"><Path d="M19.4489 11.9937C18.0661 13.4453 16.3387 13.662 14.4669 14.0785C12.5981 14.4874 11.6907 15.9067 11.0776 17.6043C10.5902 18.972 10.1181 20.9106 8.71579 21.6528C7.85691 22.1114 6.76938 22.1396 5.94392 21.5935C4.63119 20.6837 4.11027 19.0504 3.80051 17.558C3.38849 15.6012 3.04845 13.5937 3.0069 11.5888C2.96624 9.887 3.0839 7.99413 3.94357 6.47531C6.62817 1.76293 15.0312 0.470215 19.1246 4.05532C21.4688 6.09767 21.6589 9.7696 19.4489 11.9937Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPatreon;
